<mat-card class="mb-8 p-6">
  <div class="mb-4 text-lg font-medium">Job Attachments:</div>
  <div [formGroup]="parentForm">
    <div formArrayName="attachments">
      <div
        *ngFor="let att of attachments.controls; let i = index"
        [formGroupName]="i"
        class="mb-6 border-b border-gray-200 pb-4 last:border-b-0 last:pb-0 flex flex-col md:flex-row md:items-center md:gap-6"
      >
        <div class="flex-1 mb-2 md:mb-0">
          <div class="text-sm text-gray-500 mb-1">Attachment Name</div>
          <mat-form-field appearance="fill" class="w-full">
            <input matInput formControlName="name" placeholder="Attachment Name" />
          </mat-form-field>
        </div>
        <div class="flex-1 mb-2 md:mb-0">
          <div class="text-sm text-gray-500 mb-1">Document</div>
          <mat-form-field appearance="fill" class="w-full">
            <input
              [style.cursor]="'not-allowed'"
              matInput
              formControlName="document"
              placeholder="Document"
              readonly
            />
          </mat-form-field>
        </div>
        <div class="flex flex-row gap-2 items-end mb-2 md:mb-0">
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="triggerFileInput(i)"
            [disabled]="att.get('isUploading')?.value"
            *ngIf="!viewDisable && !isOrdersManager()"
          >
            <ng-container *ngIf="att.get('isUploading')?.value; else browseText">
              <mat-spinner diameter="20" class="inline-block align-middle"></mat-spinner>
            </ng-container>
            <ng-template #browseText>BROWSE</ng-template>
          </button>
          <input
            type="file"
            class="hidden"
            [attr.id]="'fileInput' + i"
            (change)="onFileSelected($event, i)"
          />
          <button
            mat-flat-button
            color="accent"
            type="button"
            (click)="viewAttachment(i)"
            [disabled]="att.get('isUploading')?.value"
          >
            VIEW
          </button>
          <button
            mat-icon-button
            color="warn"
            type="button"
            (click)="removeAttachment(i)"
            *ngIf="attachments.length > 1 && !viewDisable && !isOrdersManager()"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <div *ngIf="att.get('uploadError')?.value" class="text-red-600 text-xs mt-2 ml-1">
            {{ att.get('uploadError')?.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex justify-end mt-4" *ngIf="!viewDisable && !isOrdersManager()">
    <button mat-flat-button color="primary" type="button" (click)="addAttachment()">ADD +</button>
  </div>
</mat-card>
